const nfKW   = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const nfKWh  = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const nfEur  = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const nfEur3 = new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 3, maximumFractionDigits: 3 });

export function fmtKw(watts: number): string {
  if (Math.abs(watts) < 100) return '0 kW';
  const kW = watts / 1000;
  return `${nfKW.format(kW)} kW`;
}

/** Waarde ín een flowbol (r=32): vanaf 100 kW zonder decimaal, want
 *  "273,4 kW" is breder dan de koorde van de bol en liep over de rand
 *  (Erdotex, 19-10-2026). Onder 100 kW identiek aan fmtKw, dus VJ/NS/HO
 *  zien geen verschil. */
export function fmtKwBol(watts: number): string {
  if (Math.abs(watts) < 100_000) return fmtKw(watts);
  return `${Math.round(watts / 1000)} kW`;
}

export function fmtKwh(kwh: number): string {
  return `${nfKWh.format(kwh)} kWh`;
}

export function fmtEur(eur: number): string {
  return `€ ${nfEur.format(eur)}`;
}

export function fmtEurPerKwh(eurPerKwh: number): string {
  return `€ ${nfEur3.format(eurPerKwh)}/kWh`;
}

export function fmtPct(pct: number): string {
  return `${Math.round(pct)}%`;
}

/**
 * Formatteer een resterende duur (ms) als compacte countdown:
 *   < 1 min →  "<1m"
 *   < 1 uur → "23m"
 *   < 1 dag → "5u 12m"
 *   anders  → "3d 4u"
 *
 * 0 of negatief → "0m" (caller dropt UI doorgaans naar inactive-state).
 */
export function fmtRemaining(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '0m';
  const totalMin = Math.floor(ms / 60_000);
  if (totalMin < 1) return '<1m';
  if (totalMin < 60) return `${totalMin}m`;
  const hours = Math.floor(totalMin / 60);
  const mins = totalMin % 60;
  if (hours < 24) return mins === 0 ? `${hours}u` : `${hours}u ${mins}m`;
  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  return remHours === 0 ? `${days}d` : `${days}d ${remHours}u`;
}
